import { SocialLoginModule } from '@abacritt/angularx-social-login';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { NgxTurnstileModule } from 'ngx-turnstile';

import { HomepageComponent } from '../homepage/homepage.component';
import { LoginCheckemailComponent } from './login-checkemail/login-checkemail.component';
import { LoginErrorComponent } from './login-error/login-error.component';
import { LoginForgotComponent } from './login-forgot/login-forgot.component';
import { LoginLoginComponent } from './login-login/login-login.component';
import { LoginMfaComponent } from './login-mfa/login-mfa.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { LoginComponent } from './login.component';
import { loginGuard } from './login.guard';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TooltipModule } from 'src/libs/tooltip/tooltip.module';
import { LoginFooterComponent } from './login-footer/login-footer.component';
import { LoginMosaicComponent } from './login-mosaic/login-mosaic.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { LoginSplashscreenComponent } from './login-splashscreen/login-splashscreen.component';
import { NgOtpInputModule } from 'ng-otp-input';

// import apwo from 'angular-password-strength-meter/zxcvbn';
const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: '',
        component: HomepageComponent,
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginLoginComponent,
        data: { animation: 'isLeft' },
      },
      {
        path: 'login/mfa',
        component: LoginMfaComponent,
        data: { animation: 'isRight' },
        canActivate: [loginGuard],
      },
      {
        path: 'register',
        component: LoginRegisterComponent,
        data: { animation: 'isRight' },
      },
      {
        path: 'register/checkemail',
        component: LoginCheckemailComponent,
        data: { animation: 'isDown' },
      },
      {
        path: 'forgot',
        component: LoginForgotComponent,
        data: { animation: 'isDown' },
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: { animation: 'isDown' },
      },
      {
        path: 'login/error',
        component: LoginErrorComponent,
        data: { animation: 'isRight' },
        canActivate: [loginGuard],
      },
    ],
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    LoginLoginComponent,
    LoginRegisterComponent,
    LoginMfaComponent,
    LoginErrorComponent,
    LoginForgotComponent,
    ResetPasswordComponent,
    LoginCheckemailComponent,
    LoginFooterComponent,
    LoginMosaicComponent,
    LoginSplashscreenComponent,
  ],
  providers: [provideZxvbnServiceForPSM()],
  imports: [
    CommonModule,
    SocialLoginModule,
    FormsModule,
    PasswordStrengthMeterComponent,
    ReactiveFormsModule,
    NgxTurnstileModule,
    RouterModule.forChild(routes),
    MatProgressBarModule,
    TooltipModule,
    NgxMasonryModule,
    NgOtpInputModule,
  ],
})
export class LoginModule {}
